import { render } from "./termsConditions.vue?vue&type=template&id=fc4c150a"
import script from "./termsConditions.vue?vue&type=script&lang=js"
export * from "./termsConditions.vue?vue&type=script&lang=js"

import "./termsConditions.vue?vue&type=style&index=0&id=fc4c150a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__